import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { createDateDef, ExceptionalOpeningHoursTypeEnum } from '@jooxter/utils';
import { IFloorExceptionalClosingHoursFormDefaultValues } from '../types/floor-exceptional-closing-hours-form.types';

export const useFloorExceptionalClosingHoursSchema = (
  defaultValues?: IFloorExceptionalClosingHoursFormDefaultValues
) => {
  const { t } = useTranslation();

  if (defaultValues) {
    return z.object({
      title: z.string().min(1, t<string>('manage-space-form.error.title.required')).default(defaultValues.title),
      start: createDateDef().default(defaultValues.start),
      end: createDateDef().default(defaultValues.end),
    });
  }

  return z.object({
    title: z.string().min(1, t<string>('manage-space-form.error.title.required')),
    start: createDateDef(),
    end: createDateDef(),
    type: z.nativeEnum(ExceptionalOpeningHoursTypeEnum),
  });
};
